type LoadingButton = HTMLButtonElement | HTMLAnchorElement;

const loadingContent =
  '<span data-loader hidden><img src="/static/images/loader.gif" /> Loading&hellip;</span>';

export const render = () => {
  const loadingButtons = Array.from(
    document.querySelectorAll<LoadingButton>(".loading-button")
  );

  const onUnloadLoadingButtons = Array.from(
    document.querySelectorAll<LoadingButton>(".onunload-loading-button")
  );

  const addLoadingContent = (btn: LoadingButton) => {
    btn.innerHTML = `${loadingContent}<span data-original>${btn.innerHTML}</span>`;
  };

  const showLoadingContent = (btn: LoadingButton) => {
    btn.querySelector("span[data-original]")?.setAttribute("hidden", "hidden");
    btn.querySelector("span[data-loader]")?.removeAttribute("hidden");
    btn.classList.add("loading", "disabled");
    btn.setAttribute("disabled", "disabled");
  };

  const hideLoadingContent = (btn: LoadingButton) => {
    btn.querySelector("span[data-original]")?.removeAttribute("hidden");
    btn.querySelector("span[data-loader]")?.setAttribute("hidden", "hidden");
    btn.classList.remove("loading", "disabled");
    btn.removeAttribute("disabled");
  };

  if (loadingButtons.length > 0) {
    loadingButtons.forEach(addLoadingContent);

    loadingButtons.forEach((btn) => {
      btn.addEventListener("click", () => showLoadingContent(btn));
    });
  }

  if (onUnloadLoadingButtons.length > 0) {
    onUnloadLoadingButtons.forEach(addLoadingContent);

    // pagehide doesn't fire reliably for desktop browsers
    // reverting to beforeunload event listener
/*    
    window.addEventListener("beforeunload", () => {
      onUnloadLoadingButtons.forEach(showLoadingContent);
      return undefined;
    });
*/
    // manually simulate the form to get around pageunload not working in safari
    // will also need anchors tags to simulate loading before actually loading the next page
    onUnloadLoadingButtons.forEach((btn) => {
      btn.addEventListener("click", (event: Event) => {
        if (btn.getAttribute('type') === 'submit') {
          const submitButton = btn as HTMLButtonElement;
          if (submitButton.disabled) {
            return;
          }

          const form = (btn.getAttribute('form'))
            ? document.querySelector<HTMLFormElement>(`#${btn.getAttribute('form')}`)
            : btn.closest<HTMLFormElement>('form');

            if(form){
              if (form.checkValidity()) {
                showLoadingContent(btn);
                window.setTimeout(() => {
                  if (form.dispatchEvent(new Event('submit'))) {
                    form.submit();
                  }
                }, 500);
              }
            }
            
        } else if (btn.getAttribute('href') !== null) {
          const linkButton = btn as HTMLAnchorElement;
          onUnloadLoadingButtons.forEach(showLoadingContent);
          window.setTimeout(() => {
            window.location.href = linkButton.getAttribute('href');
          }, 500);

          event.preventDefault();
          return false;
        }
      })
    })
  }

  window.addEventListener("pageshow", () => {
    if (loadingButtons.length > 0) {
      loadingButtons.forEach(hideLoadingContent);
    }

    if (onUnloadLoadingButtons.length > 0) {
      onUnloadLoadingButtons.forEach(hideLoadingContent);
    }
  });
};
